import React from 'react'
import { Buttons, Close } from './Buttons'
import { FaTimes } from "react-icons/fa";
import './PageTitle.css'
const PageTitle = ({PageTitle}) => {
 
  return (
    <div className='py-2 fw-bold mb-0 fw-bold text-primary'>{PageTitle}</div>
  )
}
const PageHead =({pagehead,onClick})=>{
 
  return(
    
    <div className='create-head' >
        <div className='mb-0 fw-bold text-primary'>{pagehead}</div>
        <div className="ms-auto">
            <Close lable={<><FaTimes /></>} onClick={onClick}/>
        </div>
    </div>
  )
}
const PageBottom =()=>{
  return(
    <div className='text-end py-3 ' >
      <span className='mx-2'><Buttons lable={<>Save & New</>}/></span>
      <span className='mx-2'><Buttons lable={<>Save</>}/></span>
       
    </div>
  )
}
export {PageTitle,PageHead,PageBottom}